import { Component } from '@angular/core';
import { QueryParams } from '@ov-suite/helpers-shared';
import { InventoryHeldByUserCountModel } from '../models/inventory-held-by-user-count.model';

@Component({
  selector: 'ov-suite-inventory-held-by-user',
  templateUrl: './inventory-held-by-user-list.component.html',
  styleUrls: ['./inventory-held-by-user-list.component.scss'],
})
export class InventoryHeldByUserListComponent {
  formClass = InventoryHeldByUserCountModel;

  filter: Record<string, QueryParams[]> = {
    exitTime: [{ operator: 'IS', value: null }],
  };
}
